import { CardStackData } from '@tenants/types/tenant';
import { Colors } from 'constants/colors';
import { joinExpCaPaths, joinExpUsPaths, Namespaces } from 'types/locales';

export function createCardStackData(namespace: typeof Namespaces.JOIN_EXP_US | typeof Namespaces.JOIN_EXP_CA) {

  const cardStack_freedom_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.freedom.title`;
  const cardStack_freedom_description: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.freedom.description`;
  const cardStack_freedom_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.freedom.imageAlt`;

  const cardStack_ownership_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.ownership.title`;
  const cardStack_ownership_description: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.ownership.description`;
  const cardStack_ownership_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.ownership.imageAlt`;
  const cardStack_growth_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.growth.title`;

  const cardStack_growth_description: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.growth.description`;
  const cardStack_growth_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.growth.imageAlt`;

  const cardStack_community_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.community.title`;
  const cardStack_community_description: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.community.description`;
  const cardStack_community_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:cardStack.community.imageAlt`;

  const cardStackData: CardStackData = {
    title: cardStack_freedom_title,
    content:
    [
      {
        title: cardStack_freedom_title,
        description: cardStack_freedom_description,
        imageSrc: '/next/assets/images/join-expus/card-stack-image-1.png',
        backgroundColor: Colors.expSecondaryDarkNavy,
        textColor: Colors.white,
        imageAlt: cardStack_freedom_imageAlt,
      },
      {
        title: cardStack_ownership_title,
        description: cardStack_ownership_description,
        imageSrc: '/next/assets/images/join-expus/card-stack-image-2.png',
        backgroundColor: Colors.darkNavyLight,
        textColor: Colors.white,
        imageAlt: cardStack_ownership_imageAlt,
      },
      {
        title: cardStack_growth_title,
        description: cardStack_growth_description,
        imageSrc: '/next/assets/images/join-expus/card-stack-image-3.png',
        backgroundColor: Colors.lightGrayishBlue,
        textColor: Colors.expSecondaryDarkNavy,
        imageAlt: cardStack_growth_imageAlt,
      },
      {
        title: cardStack_community_title,
        description: cardStack_community_description,
        imageSrc: '/next/assets/images/join-expus/card-stack-image-4.png',
        backgroundColor: Colors.lightGrayishBlue2,
        textColor: Colors.expSecondaryDarkNavy,
        imageAlt: cardStack_community_imageAlt,
      },
    ]} as const;
  return cardStackData;
}